import { FiClock, FiCheckCircle } from 'react-icons/fi';
import { ILinkItemProps } from '../SidebarItem';

type MenuLanguage = 'en' | 'zh';

const menuText = {
  en: {
    pending: 'Pending',
    completed: 'Completed',
  },
  zh: {
    pending: '待完成',
    completed: '已完成',
  },
} as const;

export const getStudentSidebarLinkItems = (
  language?: string,
): Array<ILinkItemProps> => {
  const resolvedLanguage: MenuLanguage = language === 'zh' ? 'zh' : 'en';
  const t = menuText[resolvedLanguage];

  return [
    { name: t.pending, icon: FiClock, link: '/student/pending' },
    { name: t.completed, icon: FiCheckCircle, link: '/student/completed' },
  ];
};
